import { CheckIcon, Information, SubtractIcon } from '@farol-ds/react'
import { Table } from '@jusbrasil-web/shared-table'
import classNames from 'classnames'

import styles from './compare-plans-table.module.scss'
import { Benefit, Plan } from './types'

export interface ComparePlansTableProps {
  plans: Plan[]
  benefits: Benefit[]
}

export function ComparePlansTable(props: ComparePlansTableProps) {
  const { plans, benefits } = props

  return (
    <Table size="md">
      <Table.Header>
        <Table.Row>
          <Table.ColumnHeaderCell className={styles.tableHeader}>
            Funcionalidades
          </Table.ColumnHeaderCell>
          {plans.map((plan, index) => (
            <Table.ColumnHeaderCell
              key={index}
              justify="center"
              className={classNames(styles.tableHeader, plan.className)}
            >
              {plan.label}
            </Table.ColumnHeaderCell>
          ))}
        </Table.Row>
      </Table.Header>

      <Table.Body>
        {benefits.map((benefit, index) => (
          <Table.Row key={index} className={styles.tableRow}>
            <Table.RowHeaderCell className={styles.rowHeaderCell}>
              <div className={styles.rowHeaderContent}>
                <div className={styles.rowHeaderDescription}>
                  {benefit.icon}
                  <p dangerouslySetInnerHTML={{ __html: benefit.description }} />
                </div>
                {!!benefit.popoverDescription && <Information label={benefit.popoverDescription} />}
              </div>
            </Table.RowHeaderCell>

            {benefit.planFeatures.map(({ contains, label, className = '' }, index) => (
              <Table.Cell
                key={index}
                justify="center"
                className={classNames(styles.tableCell, className)}
              >
                <>
                  {contains ? (
                    <CheckIcon aria-label={label} className={styles.iconCheck} />
                  ) : (
                    <SubtractIcon aria-label={label} className={styles.iconSubtract} />
                  )}
                </>
              </Table.Cell>
            ))}
          </Table.Row>
        ))}
      </Table.Body>
    </Table>
  )
}
